import {
    req,
    rysReqloading,
    rysRequestXcx,
    kxsRequestXcx
} from '@/utils/request'
import axios from 'axios'

//  获取注册页面的 隐私政策  
export function getLoaing (data) {
    return req({ //需要loading加载
        url: '/app/homeArticle/list',
        method: 'post',
        data: data
    })
}

// 获取 密钥
export function getKeys () {
    return req({
        url: `/system/encrypt/getInfo`,
        method: 'get',
    })
}

// 获取奖品列表
export function getListofWinners (data) {
    return req({
        // url: `/system/app/sysLotteryActivity/getPrizeRewardInfo?orderNo=${ id }`,
        url: `/system/encrypt/processWithNoToken`,
        method: 'post',
        data
    })
}

// 抽奖
export function getDrawward (data) {
    return req({ //需要loading加载
        // url: `/system/app/sysLotteryActivity/prizeReward`,
        url: `/system/encrypt/processWithNoToken`,
        method: 'post',
        data: data
    })
}